export enum ResultHeaderEnum {
    DOMAIN = "Domain Name",
    AUCTION_TYPE = "Auction Type",
    MY_BID = "My Bid",
    PROGRESS_STATUS = "Progress Status",
    AUCTION_END = "Auction End",
    BIDDERS = "Bidders",
}
